import React from 'react';
import { ApolloError } from '@apollo/client';
import { Link } from 'react-router-dom';

import { Button, EditIcon } from '@occc/ui-design-system';
import { useAppLayoutContextConsumer, Page } from '@occc-app/design-system';
import { ProductGroupFragment } from '@occc/graphql';
import { useIsUserPermittedTo, Feature } from '@occc/utils-access-control';

import { getProductGroupPageHeaderLinks } from './utils';
import { ProductGroupDetails } from './ProductGroupDetails';

import { routeCreator } from '../utils';

const PAGE_TITLE = 'Product Group Details';

type ProductGroupDetailsPageProps = {
  loading: boolean;
  error?: ApolloError;
  productGroup?: ProductGroupFragment | null;
};

const ProductGroupDetailsPage = ({
  loading,
  error,
  productGroup,
}: ProductGroupDetailsPageProps) => {
  const links = React.useMemo(() => getProductGroupPageHeaderLinks(productGroup), [productGroup]);
  useAppLayoutContextConsumer(links);

  const isUserPermittedToEditProductGroup = useIsUserPermittedTo(Feature.PRODUCT_GROUP_EDIT);
  const isEditButtonVisible = isUserPermittedToEditProductGroup && productGroup;

  return (
    <Page
      browserTabTitle={PAGE_TITLE}
      pageHeaderProps={{
        title: PAGE_TITLE,
      }}
      containerProps={{ variant: 'md' }}
      actions={
        isEditButtonVisible && (
          <Button
            color='secondary'
            variant='contained'
            component={Link}
            to={routeCreator.update(productGroup.id)}
            startIcon={<EditIcon />}
            role='button'
          >
            Edit
          </Button>
        )
      }
    >
      <ProductGroupDetails loading={loading} error={error} productGroup={productGroup} />
    </Page>
  );
};

export default ProductGroupDetailsPage;
